import React from 'react';
import { pathOr } from 'ramda';
import Form from 'components/Form';
import useCreateJobPostStep from 'modules/JobPosts/hooks/useCreateJobPostStep';
import { startCreateJobPostSubmit, resolveCreateJobPostSubmit } from 'modules/JobPosts/actions';
import { getJobPostInitialValues } from 'selectors/jobPosts';
import JobPositionStep from './JobPositionStep';
import JobRequirementsStep from './JobRequirementsStep';
import InterviewProcess from './InterviewProcess';
import InformationForRecruiterStep from './InformationForRecruiterStep';
import FormStepLabels from '../FormStepLabels';

interface CreateJobPostFormProps {
  initialValues?: any;
  jobPostId?: number;
}

const CreateJobPostForm: React.FC<CreateJobPostFormProps> = (props): JSX.Element => {
  const { initialValues, jobPostId } = props;
  const { formStep, setNextFormStepHandler, setPreviousFormStepHandler } = useCreateJobPostStep();
  const jobPostInitialValues = getJobPostInitialValues(initialValues);
  const status = pathOr('', ['status'], initialValues);
  return (
    <>
      <FormStepLabels showLabels={formStep < 5} formStep={formStep} />
      <Form
        startSubmitAction={startCreateJobPostSubmit().type}
        resolveSubmitAction={resolveCreateJobPostSubmit().type}
        initialValues={jobPostInitialValues}
        setPayload={(action: object, payload: any) => ({
          ...action,
          payload: {
            ...payload,
            jobPostId,
            status,
          },
        })}
      >
        {(formProps: any) => {
          const { form, hasValidationErrors, values, submitting, submitErrors } = formProps;
          switch (formStep) {
            case 1:
              return (
                <JobPositionStep
                  values={values}
                  handleSubmit={form.submit}
                  hasValidationErrors={hasValidationErrors}
                  setNextFormStepHandler={setNextFormStepHandler}
                />
              );
            case 2:
              return (
                <JobRequirementsStep
                  handleSubmit={form.submit}
                  hasValidationErrors={hasValidationErrors}
                  setNextFormStepHandler={setNextFormStepHandler}
                  setPreviousFormStepHandler={setPreviousFormStepHandler}
                />
              );
            case 3:
              return (
                <InterviewProcess
                  values={values}
                  handleSubmit={form.submit}
                  hasValidationErrors={hasValidationErrors}
                  setNextFormStepHandler={setNextFormStepHandler}
                  setPreviousFormStepHandler={setPreviousFormStepHandler}
                />
              );
            case 4:
              return (
                <InformationForRecruiterStep
                  submitting={submitting}
                  submitErrors={submitErrors}
                  setNextFormStepHandler={setNextFormStepHandler}
                  setPreviousFormStepHandler={setPreviousFormStepHandler}
                  values={values}
                  status={status}
                />
              );
            default:
              return null;
          }
        }}
      </Form>
    </>
  );
};

export default CreateJobPostForm;
